import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

/* Components */
import Icon from 'src/components/HTKit/Icon';
import {LoaderComponent} from 'src/components/Loader';

// Utils && Hoks
import {useIsImageLoading} from 'src/components/Elements/ThumbnailDisplay/thumbnail.display.hooks';
import {noop} from 'src/utils/event';
import {getImageElementConfig} from './thumbnail.display.utils';

import styles from './thumbnailDisplay.styles.scss';

export const TEST_IDS = {
  DOWNLOAD_BUTTON: 'thumbnail-download-button',
  DELETE_BUTTON: 'thumbnail-delete-button',
  THUMBNAIL: 'thumbnail',
  LOADING_INDICATOR: 'thumbnail-loading-indicator',
};

/** char length 18 is an eyeballed value that looks good */
export const MAX_FILENAME_LENGTH = 18;

const Thumbnail = ({dataIndex, file, className, thumbnailClassName}) => {
  const {isImageLoading, handleImageLoad} = useIsImageLoading();

  if (!file) return null;

  const {showDeleteButton, onDeleteClick = noop, onThumbnailClick = noop} = file;
  const {imgSrc, altText, imgClass, transformedFile} = getImageElementConfig(file);

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    onDeleteClick(file);
  };

  const handleThumbnailClick = (e) => {
    e.stopPropagation();
    onThumbnailClick(file);
  };

  /* Style declarations */
  const actionButtonStyles = cn(styles.thumbnailActionButton, 'plainButton');
  return (
    <div data-index={dataIndex} className={cn(styles.thumbnail, className, thumbnailClassName)} onClick={handleThumbnailClick}>
      <div className={styles.thumbnailContent}>
        {isImageLoading && (
          <div className="fullheight fullwidth">
            <LoaderComponent containerClassName="fullheight fullwidth" />
          </div>
        )}
        <img src={transformedFile || imgSrc} alt={altText} className={imgClass} onLoad={handleImageLoad} />
        <div className={styles.thumbnailButtonContainer}>
          {showDeleteButton && (
            <button type="button" onClick={handleDeleteClick} className={actionButtonStyles}>
              <Icon name="x" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

Thumbnail.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string,
    showDownloadButton: PropTypes.bool,
    showDeleteButton: PropTypes.bool,
    onDownloadClick: PropTypes.func,
    onDeleteClick: PropTypes.func,
    onThumbnailClick: PropTypes.func,
  }),
  className: PropTypes.string,
  suppressNameplate: PropTypes.bool,
  thumbnailClassName: PropTypes.string,
  dataIndex: PropTypes.number,
}

export default Thumbnail;
